import { render, staticRenderFns } from "./ScannedRecordCreate.vue?vue&type=template&id=f94c8fa0&"
import script from "./ScannedRecordCreate.vue?vue&type=script&lang=js&"
export * from "./ScannedRecordCreate.vue?vue&type=script&lang=js&"
import style0 from "./ScannedRecordCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports